import axios from '@/axios'
const jwt = require('jsonwebtoken')
const decoded = jwt.verify(localStorage.usertoken, 'secret')  
const viewId = decoded.id
const token = localStorage.usertoken

export default {
  cansee(slug, type) {
		return new Promise(async (resolve, reject) => {
			try {    	
	      const userPemData = JSON.parse(localStorage.userAllData)
	      const userD = JSON.parse(userPemData['user_role']['user_role_permissions'][0]['permissions_json'])
	      const matchingKey = Object.keys(userD).find(key => key+'-'+type === slug);
	      const showP = matchingKey !== undefined && userD[matchingKey][type] ? true : false

	      // axios.get('/api/insight/auth', {
	      // 	headers: { 'Authorization': localStorage.usertoken }
	      // }).then((result) => {
	      // 	localStorage.removeItem('Insight_URL')
	      //   localStorage.setItem('Insight_URL', result.data.Insight_URL)
	      //   return result.data.Insight_URL
	      // })

	    	resolve(showP)
			} catch(err) {
				window.location.href = "/not-authorized"
				reject(err.toString('utf8'));
			}
		})
  },

  async auth(token) {
  	try {  		
			const d = await axios.get(`/api/auth`, {
	      headers: { 'Authorization': token }
	    })
	    
			if (d['data'] == 'access_denied') {
	      window.location.href = "/not-authorized"
	    }
  	} catch(err) {
  		console.log(err)
  	}
  },

  async loadUserVal() {
    var d = await axios.get(`/user/view/${viewId}`, {
      headers: { 'Authorization': token }
    }) 
    
    const userD = d['data'][0]['user_role']['val']
    return userD
  },

  async loadUserAccessLevel() {
    var d = await axios.get(`/user/view/${viewId}`, {
      headers: { 'Authorization': token }
    }) 
    const userD = d['data'][0]['user_role']['access_level']
    console.log('access_level ', userD)
    return userD
  },
}